export const setUrlLinkSource = (data) => {
  return {
    type: "SET_URL_LINK_SOURCE",
    payload: data,
  };
};

export const clearUrlLinkSource = () => {
  return {
    type: "CLEAR_URL_LINK_SOURCE",
  };
};

export const setDocumentIdValue = (payload) => {
  return {
    type: "SET_DOCUMENT_ID_VALUE",
    payload,
  };
};

export const setShowKeyboard = (payload) => {
  return {
    type: "SET_SHOW_KEYBOARD",
    payload,
  };
};

export const setUrlTotemId = (payload) => {
  return {
    type: "SET_URL_TOTEM_ID",
    payload,
  };
};

export const downloadToken = (payload) => {
  return {
    type: "SET_DOWNLOAD_EVENT",
    payload,
  };
};
